import $http from '../services/AxiosInstance';
import { IConfigCertificate } from '../types/configCertificate.type';

interface Params {
  page?: number;
  search?: string;
  deleted?: boolean;
}

class ConfigCertificatesRepository {
  static async getConfigCerticates(params: Params = {}) {
    try {
      let url = `/certificates-config`;
      if (params.page) {
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async getConfigCerticatesByCompanyId(id: Number) {
    try {
      let url = `/certificates-config/company/${id}`;
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createConfigCertificateRecord(data: any): Promise<IConfigCertificate> {
    try {
      const response = await $http.post('/certificates-config', data);

      return response.data.data;
    } catch (error) {
      throw Error;
    }
  }
  static async updateConfigCertificateRecord(data: any): Promise<IConfigCertificate> {
    try {
      const response = await $http.patch(`/certificates-config/${data.id}`, data);
      return response.data.data;
    } catch (error) {
      throw Error;
    }
  }
  static async deleteConfigCertificate(id: number): Promise<IConfigCertificate> {
    try {
      const response = await $http.delete(`certificates-config/${id}`)
      return response.data;
    } catch (errors: any) {
      return errors;
    }
  }
  static async restoreConfigCertificate(id: number): Promise<IConfigCertificate> {
    try {
      const response = await $http.patch(`certificates-config/restore/${id}`);
      return response.data;
    } catch (errors: any) {
      return errors;
    }
  }
}


export default ConfigCertificatesRepository;
